// Ported from src/utils/format.ts — used by the client-side cart drawer,
// which has no server round-trip to format currency/labels for it.
export function formatCurrency(value) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value)
}

export function conditionLabel(condition) {
  return condition?.toLowerCase() === "novo" ? "Novo" : "Usado"
}

const ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }

// The drawer renders cart items (sourced from localStorage) via innerHTML
// templates, so any text interpolated into them must be escaped.
export function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (char) => ESCAPES[char])
}
